'use client';

import Image from 'next/image';

import SfLogoMain from '@/assets/icons/sidebar-nav/sportsfi-logo-main';
import { Button } from '@/components/ui/Button';
import { SIGNED_OUT_PATH } from '@/lib/auth/appAccess';
import { SESSION_VALIDATION_ERROR_MESSAGE } from '@/lib/auth/sessionErrors';
import { handleSignOut } from '@/lib/utils/auth';

type AuthSessionErrorPanelProps = {
  buttonLabel?: string;
  description?: string;
  onSignOutClick?: () => void;
};

export default function AuthSessionErrorPanel({
  buttonLabel = 'Sign out',
  description = SESSION_VALIDATION_ERROR_MESSAGE,
  onSignOutClick,
}: AuthSessionErrorPanelProps): React.ReactNode {
  const handleSignOutClick = () => {
    if (onSignOutClick != null) {
      onSignOutClick();

      return;
    }

    void handleSignOut({ callbackUrl: SIGNED_OUT_PATH, skipConfirmation: true });
  };

  return (
    <>
      <Image
        src="/images/bg_lights.png"
        alt="SportsFi Background"
        fill
        priority
        className="object-cover brightness-50"
      />

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 text-center text-white">
        <div className="mb-8">
          <SfLogoMain />
        </div>

        <section className="w-full max-w-md rounded-md border border-white/15 bg-black/55 p-6 shadow-xl backdrop-blur">
          <div className="space-y-4">
            <p className="rounded-md border border-red-300/50 bg-red-950/60 p-3 text-sm text-red-100">{description}</p>
            <Button type="button" variant="secondary" onClick={handleSignOutClick} className="min-w-40">
              {buttonLabel}
            </Button>
          </div>
        </section>
      </div>
    </>
  );
}
